import { createSlice } from '@reduxjs/toolkit';
import dayjs from 'dayjs';
import { toJS } from 'mobx';

const productsSlice = createSlice({
    name: 'product',
    initialState: {
        data: [],
        lastUpdated: localStorage.getItem('lastUpdated') || null, // استرجاع آخر وقت تحديث من localStorage
        vouchers: [],
        hanging: []
    },
    reducers: {
        setProducts: (state, action) => {
            state.data = action?.payload?.payload;
            state.lastUpdated = new Date().toISOString();
            localStorage.setItem('lastUpdated', state.lastUpdated); // حفظ وقت التحديث في localStorage
        },
        setVouchers: (state, action) => {
            state.vouchers = action?.payload;
        },
        clearOldVoucher: (state) => {
            const today = dayjs(new Date()).format('YYYY-MM-DD'); // تاريخ اليوم بصيغة YYYY-MM-DD
            state.vouchers = state.vouchers.filter(item => {
                return item?.dateStored === today // الاحتفاظ فقط بالبيانات الخاصة باليوم الحالي
            }
            );
            // localStorage.setItem('storedData', JSON.stringify(state.data)); // تحديث الكاش
        },
        setHanging: (state, action) => {
            state.hanging = action?.payload;
        },
        initialProduct: (state, action) => {
            state.data = [];
            state.vouchers = [];
            state.hanging = [];
            state.lastUpdated = null;
            localStorage.clear(); // حفظ وقت التحديث في localStorage
        },

    },
});

export const { setProducts, setVouchers, setHanging, initialProduct, clearOldVoucher } = productsSlice.actions;
export default productsSlice.reducer;
